module.exports = __webpack_public_path__ + "img/x2.c71bfc3c.jpg";